import { Component } from 'react';
import { HotmartRum } from '@hot-observability-js/react';
function logError(error, errorInfo, user) {
    if (process.env.NODE_ENV !== 'production') {
        console.error(error, errorInfo);
        return;
    }
    HotmartRum.withScope((scope) => {
        scope.setLevel('error');
        if (user?.id && user?.email) {
            scope.setUser({ id: user?.id, email: user?.email });
        }
        HotmartRum.captureMessage(String(errorInfo?.componentStack));
        HotmartRum.captureException(error);
    });
}
export class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { hasError: false }
        });
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        logError(error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            return this.props.fallback;
        }
        return this.props.children;
    }
}
